import Environment from "../services/interfaces/Environment";

const _environment: Environment = {
    isProduction: false,
    targetClient: 'https://test.chasethefox.com/',
    targetServer: 'https://test.chasethefox.com/',
    targetCdn: 'https://cdn.chasethefox.com/',
};

export default _environment;